import { styled } from "@mui/material";

export const Panel = styled("div")<{ standalone: boolean }>((standalone) => ({
  position: "relative",
  display: "flex",
  height: "100%",
  background: "#fff",
  flexDirection: "column",
  borderRadius: standalone ? 12 : "0 12px 12px 0",

  "> *:last-child": {
    flex: "1 1 100%",
  },
}));
